module.exports = __webpack_public_path__ + "f52ff61df6f08254f60ba2005cf3bdec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/les-aliments-bercy/03.jpg
// module id = KsIJ
// module chunks = 0